export const backendUrl = () => {
    if (import.meta.env.VITE_USE_STAGING) {
        return "https://internal-api-staging.fantasychess.app";
    }

    if (
        window.location.hostname.startsWith("pr-") &&
        window.location.hostname.endsWith(".fly.dev") &&
        window.location.hostname.includes("cms")
    ) {
        const host = window.location.hostname.replace("cms", "api");
        return `https://${host}`;
    }

    if (window.location.hostname == "cms.fantasychess.app") {
        return "https://internal-api.fantasychess.app";
    }

    if (window.location.hostname == "cms-staging.fantasychess.app") {
        return "https://internal-api-staging.fantasychess.app";
    }

    return "http://localhost:8085";
};

export const cdnUrl = () => {
    if (import.meta.env.VITE_USE_STAGING) {
        return "https://cdn-staging.fantasychess.app";
    }

    if (
        window.location.hostname.startsWith("pr-") &&
        window.location.hostname.endsWith(".fly.dev") &&
        window.location.hostname.includes("cms")
    ) {
        const host = window.location.hostname.replace("cms", "api");
        return `https://${host}`;
    }

    if (window.location.hostname == "cms.fantasychess.app") {
        return "https://cdn.fantasychess.app";
    }

    if (window.location.hostname == "cms-staging.fantasychess.app") {
        return "https://cdn-staging.fantasychess.app";
    }

    return "http://localhost:8085";
};

export const wsUrl = () => {
    if (import.meta.env.VITE_USE_STAGING) {
        return "wss://edge-staging.fantasychess.app/ws";
    }

    if (
        window.location.hostname.startsWith("pr-") &&
        window.location.hostname.endsWith(".fly.dev") &&
        window.location.hostname.includes("cms")
    ) {
        const host = window.location.hostname.replace("cms", "api");
        return `wss://${host}/ws`;
    }

    if (window.location.hostname == "cms.fantasychess.app") {
        return "wss://edge.taketaketake.com/ws";
    }

    if (window.location.hostname == "cms-staging.fantasychess.app") {
        return "wss://edge-staging.fantasychess.app/ws";
    }

    return "ws://localhost:8089/ws";
};
